module.exports = __webpack_public_path__ + "img/JobApplication.91b5e7bb.svg";